<template>
  <div>
    <h1 class="display-3">Aktualności</h1><br/>

    <ul class="list-unstyled">
      <div v-for="msg in news" :key="msg.id">
        <b-media tag="li" class="mb-3">
          <b-img slot="aside" :src="msg.img" width="120"/>
          <h5 class="mt-0 mb-2">
            <router-link class="router-link-list" active-class="activeSide" :to="msg.url" exact>{{msg.title}}</router-link>
          </h5>
          <b-row>
            <b-col cols="10">
              {{msg.text}}<router-link active-class="activeSide" :to="msg.url" exact>.....więcej</router-link>
            </b-col>
          </b-row>
        </b-media>
      </div>
    </ul>
  </div>
</template>

<script>
import aktualnosci from '@/models/aktualnosci.js'

export default {
  name: 'aktualnosci',
  data: function(){
    return{
      news: aktualnosci.news
    }
  },
  metaInfo:{
    title: 'Aktualności',
    meta:[
      {name: 'description', content: 'AK Wilno - Aktualności ze strony' },
      {name: 'og:url', content: 'http://akwilno.pl/aktualnosci' },
      {name: 'og:title', content: 'Aktualności' },
      {name: 'og:image', content: '/aktualnosci/relacja_z_obchodow.jpg' },
      {name: 'og:description', content: 'AK Wilno - Aktualności ze strony' },
      {name: 'twitter:url', content: 'http://akwilno.pl/aktualnosci' },
      {name: 'twitter:title', content: 'AK Wilno' },
      {name: 'witter:image', content: '/aktualnosci/relacja_z_obchodow.jpg' },
      {name: 'twitter:description', content: 'AK Wilno - Aktualności ze strony' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aktualnosci.vue